<template>
  <div class="about">
    <div class="container mx-auto">
      <div class="row">
        <div class="text-left">
          <br />
          <h1>Profile</h1>
          <br />
          <label for="name">
            <h5>Name</h5>
          </label>
          <p id="name">飯島 聡</p>
          <label for="city">
            <h5>Address</h5>
          </label>
          <p id="city">千葉県市川市</p>
          <label for="interestp">
            <h5>興味:プログラミング</h5>
          </label>
          <p id="interestp">統計をつかったよーなやつ、R,python,firebase,vueなど。atcoder緑の雑魚derだが、
            算数に比較的強いのでDLの茶番は見抜けた。物理学士。</p>
          <label for="interest">
            <h5>興味:音楽</h5>
          </label>
          <p id="interest">作曲、ピアノ（音大中退）。Bach,Beethoven,Ravel,チャイコあたりが特に好き。
            ブラームスは偉大だと思うが、凝りすぎててまだよくわからない曲も多い。</p>
          <label for="interestmusic">
            <h5>興味:その他</h5>
          </label>
          <p id="interest">卓球（両面ペン）、バックドライブが自慢だがフォアハンドが課題。相手募集。</p>        
        <br>
        email: iijimasat@gmail.com<br>
        <a href="https://twitter.com/biones">twitter:</a> https://twitter.com/biones
        </div>
      </div>
    </div>

    <!--
<div v-html="content">{{content}}</div>

    <b-container class="bv-example-row">
  <b-row>
    <b-col>1 of 3</b-col>
    <b-col>2 of 3</b-col>
    <b-col>3 of 3</b-col>
  </b-row>
</b-container>
<ul><li>千葉県市川市</li></ul>
    -->
  </div>
</template>
<script>
export default {
  name: "about",
  data() {
    return {
      content: null
    };
  },
  created() {

    /*
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute(
      "src",
      "https://cdn.jsdelivr.net/npm/marked/marked.min.js"
    );
    document.head.appendChild(recaptchaScript);
    this.content = marked(
      "# profile \n\n \n\n <br>\
            ## address\n\n\
            千葉県市川市\n\
        [email](mauriceiijima@gmail.com)"
    );
    */
  }
};
</script>